var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ffc800;}.cls-1{opacity:0.1;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.78,29c.13-.76.28-1.66.43-2.56.11-.66.21-1.32.35-2a.9.9,0,0,0-.28-.88l-3-2.94a1.9,1.9,0,0,1-.63-2.14,2,2,0,0,1,1.78-1.35c1.34-.17,2.68-.39,4-.57a1.11,1.11,0,0,0,1-.7c.59-1.25,1.22-2.48,1.82-3.72a1.95,1.95,0,0,1,3.6,0c.61,1.25,1.25,2.49,1.84,3.75a1.08,1.08,0,0,0,.91.65l4.13.59a2,2,0,0,1,1.71,1.34,1.86,1.86,0,0,1-.56,2.05c-1,1-2,2-3,2.95a1,1,0,0,0-.36,1.05c.27,1.4.49,2.8.73,4.2a1.94,1.94,0,0,1-2.84,2.09c-1.27-.66-2.54-1.32-3.8-2a1,1,0,0,0-1.08,0c-1.27.69-2.55,1.37-3.85,2A2,2,0,0,1,13.78,29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.92197f4106956781e0a9532361dd478f.svg";
export { ForwardRef as ReactComponent };